import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import DashboardReport from "../../../services/api/dashboard";

const ANIMATION_DURATION = 18;

function NotificationSummaryCard({ title }) {
  const [items, setItems] = useState([]);
  const [isMarquee, setIsMarquee] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  // const navigate = useNavigate();

  const notificationRequest = async () => {
    try {
      const response = await DashboardReport.notificationRequest();
      // console.log("notificationss", response);

      const icons = [
        {
          iconBg: "#FFEB3B",
          icon: (
            <svg
              width="12"
              height="12"
              fill="currentColor"
              style={{ color: "#fff" }}
            >
              <circle cx="6" cy="4" r="3" />
              <rect x="2" y="8" width="8" height="3" rx="1.5" />
            </svg>
          ),
        },
        {
          iconBg: "#8BC34A",
          icon: (
            <svg
              width="12"
              height="12"
              fill="currentColor"
              style={{ color: "#fff" }}
            >
              <circle cx="4" cy="4" r="2.2" />
              <circle cx="9" cy="7" r="2.2" />
            </svg>
          ),
        },
      ];

      // Build list dynamically based on API data
      const dynamicItems =
        response?.messages?.map((msg, idx) => ({
          id: msg.id,
          text: msg.text,
          path: msg.path,
          ...icons[idx % icons.length],
        })) || [];

      setItems(dynamicItems);
      setIsMarquee(dynamicItems.length > 5);
    } catch (error) {
      console.error("Error loading notifications:", error);
    }
  };

  useEffect(() => {
    notificationRequest();
  }, []);

  const marqueeList = isMarquee ? [...items, ...items.slice(0, 5)] : items;

  return (
    <div
      style={{
        margin: "16px 0 18px 0",
        background: "#ffffff",
        borderRadius: isMobile ? "12px" : "16px",
        border: "1.5px solid #FFE09A",
        boxShadow: "0 4px 14px rgba(235,190,80,0.08)",
        padding: isMobile ? "14px" : "18px 18px 16px 18px",
        position: "relative",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* 🔹 Title & Badge Container */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: isMobile ? 8 : 12,
          marginBottom: isMobile ? "10px" : "12px",
          flexWrap: "nowrap",
        }}
      >
        {/* Title */}
        <span
          style={{
            fontWeight: 600,
            fontSize: isMobile ? 15 : 18,
            color: "#2C356A",
            letterSpacing: "-.6px",
            lineHeight: 1.3,
            flex: "1 1 auto",
            minWidth: 0,
            wordBreak: "break-word",
          }}
        >
          {title}
        </span>

        {/* Badge - Now in flex container */}
        {items.length > 0 && (
          <span
            className="blink-badge"
            style={{
              background: "#FE646F",
              color: "#fff",
              borderRadius: "18px",
              fontSize: isMobile ? 11 : 13,
              fontWeight: 600,
              padding: isMobile ? "3px 10px" : "4px 12px",
              letterSpacing: ".5px",
              whiteSpace: "nowrap",
              boxShadow: "0 1px 6px 0 #f9b3b9a2",
              flexShrink: 0,
            }}
          >
            {`${items.length} NEW`}
          </span>
        )}
      </div>

      {/* 🔹 List / Marquee */}
      <div
        style={{
          height: isMarquee ? 5 * 29 : "auto",
          overflow: "hidden",
          position: "relative",
        }}
        className={isMarquee ? "marquee-outer" : ""}
      >
        <div
          className={isMarquee ? "marquee-inner" : ""}
          style={{
            display: "flex",
            flexDirection: "column",
            animation: isMarquee
              ? `marquee-slide ${ANIMATION_DURATION}s linear infinite`
              : "none",
          }}
        >
          {items.length > 0 ? (
            marqueeList.map((item) => (
              <div
                key={item.id}
                // role="button"
                // tabIndex={0}
                // onClick={() => navigate(item.path)}
                // onKeyPress={(e) => e.key === "Enter" && navigate(item.path)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: isMobile ? 13 : 14.3,
                  color: "#2C356A",
                  marginBottom: 5,
                  lineHeight: 1.4,
                  wordBreak: "break-word",
                  minHeight: 29,
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginRight: 10,
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      display: "inline-flex",
                      width: 19,
                      height: 19,
                      background: item.iconBg,
                      borderRadius: "50%",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {item.icon}
                  </span>
                </span>
                <span style={{ flex: "1 1 auto", minWidth: 0 }}>
                  {item.text}
                </span>
              </div>
            ))
          ) : (
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? 13 : 14.5,
                color: "#777",
                padding: isMobile ? "10px 0" : "12px 0",
              }}
            >
              🎉 No pending requests
            </div>
          )}
        </div>
      </div>

      {/* 🔹 Styles */}
      <style>
        {`
          @keyframes blink {
            0%, 60%, 100% { opacity: 1; }
            70% { opacity: 0.35; }
            85% { opacity: 1; }
          }
          .blink-badge {
            animation: blink 1.8s infinite;
          }
          @keyframes marquee-slide {
            0% { transform: translateY(0); }
            100% { transform: translateY(-${marqueeList.length * 29}px); }
          }
          .marquee-outer:hover .marquee-inner {
            animation-play-state: paused !important;
          }
        `}
      </style>
    </div>
  );
}

NotificationSummaryCard.propTypes = {
  title: PropTypes.string,
};

NotificationSummaryCard.defaultProps = {
  title: "Action(s) Required",
};

export function useNotificationSummaryData() {
  const icons = [
    {
      iconBg: "#FFEB3B",
      icon: (
        <svg
          width="12"
          height="12"
          fill="currentColor"
          style={{ color: "#fff" }}
        >
          {" "}
          <circle cx="6" cy="4" r="3" />{" "}
          <rect x="2" y="8" width="8" height="3" rx="1.5" />{" "}
        </svg>
      ),
    },
    {
      iconBg: "#FFD54F",
      icon: (
        <svg
          width="12"
          height="12"
          fill="currentColor"
          style={{ color: "#fff" }}
        >
          {" "}
          <circle cx="4" cy="4" r="2.2" /> <circle cx="9" cy="7" r="2.2" />{" "}
        </svg>
      ),
    },
    {
      iconBg: "#8BC34A",
      icon: (
        <svg
          width="12"
          height="12"
          fill="currentColor"
          style={{ color: "#fff" }}
        >
          {" "}
          <circle cx="6" cy="4" r="3" />{" "}
          <rect x="2" y="8" width="8" height="3" rx="1.5" />{" "}
        </svg>
      ),
    },
  ];
  return [
    { id: 1, ...icons[0], text: "You have 2 Member(s) Transfer Request" },
    { id: 2, ...icons[1], text: "3 Friend(s) transfer request" },
    {
      id: 3,
      ...icons[2],
      text: "Pending appointments for transferred/graduated leaders",
    },
    { id: 4, ...icons[2], text: "You have 1 new nomination for group leader" },
    { id: 5, ...icons[1], text: "Friend request approved" },
    { id: 6, ...icons[0], text: "4 Member(s) transfer approval pending" },
    { id: 7, ...icons[2], text: "Team leader handover required" },
    { id: 8, ...icons[1], text: "2 Friend(s) event registration required" },
    { id: 9, ...icons[2], text: "Upcoming appointment reminders" },
    { id: 10, ...icons[0], text: "1 Member(s) profile incomplete" },
  ];
}
export default NotificationSummaryCard;
